export default "__VITE_ASSET__D3K4TMov__"